import { AnimatePresence, motion } from "framer-motion";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  useAreaData,
  useGetViolatoinTypeDetails,
  usePoliceStationData,
  useShopData,
  useShopViolationDetailsPagination,
  useViolationDetailsExcel,
  useZoneData,
} from "../../API_Master/GetAPI";
import NoDataFound from "../../Components/NoDataFound";
import PageCountSelect from "../../Components/PageCountSelect";
import PageEntries from "../../Components/PageEntries";
import PaginationButtons from "../../Components/PaginationButtons";
import { exportToExcel, notifyError, validateStartAndEndDate } from "../../HelperMethods";
import { NIGHT_EYE_IMG_URL } from "../../Process";
import DirectionMap from "../DepartmentVendorLIst/DirectionMap";

const ShimmerRow = () => (
  <tr className="animate-pulse">
    <td className="py-5 px-3 pl-6">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
    <td className="py-5 px-3">
      <div className="h-5 bg-slate-200 dark:bg-slate-700 rounded"></div>
    </td>
  </tr>
);
const ViolationVendorList = () => {
  const [isFiltersOpen, setIsFiltersOpen] = useState(false); // ← starts collapsed
  const [currentPage, setCurrentPage] = useState(0); // index: 0 = page 1
  const [openTableDetails, setOpenTableDetails] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const location = useLocation();

  const [directionData, setDirectionData] = useState(null);
  const [openMapModel, setOpenMapModel] = useState(false);

  const receivedFilterData = location?.state?.filterData;
  const [filterData, setFilterData] = useState({
    isShopOpenCloseViolation: "",
    cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
    zoneID: receivedFilterData?.["zoneID"] || Cookies.get("NIGHT_EYE_ZONE_ID") || "",
    policeStationID: receivedFilterData?.["policeStationID"] || Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
    areaID: receivedFilterData?.["areaID"] || Cookies.get("NIGHT_EYE_AREA_ID") || "",
    shopDetailID: "",
    shopOwnerMobileNo: "",
    shopOwnerName: "",
    shopName: "",
    violationsTypeID: "",
    // "startDate": subDays(new Date(), 7),
    startDate: receivedFilterData?.["startDate"] || new Date(),
    endDate: receivedFilterData?.["startDate"] || new Date(),
  });
  const [modelFilter, setModelFilter] = useState({
    isShopOpenCloseViolation: "",
    cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
    zoneID: receivedFilterData?.["zoneID"] || Cookies.get("NIGHT_EYE_ZONE_ID") || "",
    policeStationID: receivedFilterData?.["policeStationID"] || Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
    areaID: receivedFilterData?.["areaID"] || Cookies.get("NIGHT_EYE_AREA_ID") || "",
    shopDetailID: "",
    shopOwnerMobileNo: "",
    shopOwnerName: "",
    shopName: "",
    violationsTypeID: "",
    // "startDate": subDays(new Date(), 7),
    startDate: receivedFilterData?.["startDate"] || new Date(),
    endDate: receivedFilterData?.["startDate"] || new Date(),
  });

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { data, fetchNextPage, hasNextPage, isFetching, isLoading, isError, refetch } = useShopViolationDetailsPagination(rowsPerPage, filterData);

  const { mutate: exportUser, isPending: isExporting } = useViolationDetailsExcel();

  const pages = data?.pages || [];
  const totalCount = data?.pages[0]?.TotalCount || 0;
  const currentItems = data?.pages[currentPage]?.data || [];

  // const vendorCount = data?.pages[currentPage]?.VendorCount || {};
  // console.log(data,"kjsdhfkajsdfkhadkljshfasd")

  const start = currentPage * rowsPerPage + 1;
  const end = Math.min(start + currentItems.length - 1, totalCount);
  const handleFilterSearch = () => {
    if (!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate)) {
      return;
    }
    setFilterData(modelFilter);
  };
  const goToPage = async (index) => {
    if (pages[index]) {
      setCurrentPage(index);
    } else if (hasNextPage) {
      await fetchNextPage(); // loads next page
      setCurrentPage(index);
    }
  };

  const openModal = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeModal = () => {
    setSelectedImage(null);
  };
  const handleRowsChange = async (e) => {
    const limit = parseInt(e.target.value);
    setRowsPerPage(limit);
    setCurrentPage(0);
    await refetch(); // reload from start
  };
  const handleExport = (exportType) => {
    toast.dismiss();
    exportUser(filterData, {
      onSuccess: (tireMaseter) => {
        if (!tireMaseter.length) {
          // return alert('No Data Found')
          return notifyError("No Data Found");
        }
        let exportData = tireMaseter.map((item, index) => {
          const vilationsType = (item?.ShopReportViolationsDetail || []).map((a) => a?.ViolationsType?.trim() || "-").join(", ") || "-";

          return {
            "Sr No ": index + 1,
            "Shop Name": item?.ShopName || "",
            // "Mobile Number": item?.ShopMobileNo1 || "",
            "Owner Name": item?.ShopOwnerDetail?.[0]?.Name || "",
            "Owner Mobile Number": item?.ShopOwnerDetail?.[0]?.MobileNo || "",
            Area: item?.AreaName || "",
            "Reported Date": item?.ReportDate || "",
            "Reported Time": item?.ReportTime || "",
            Description: item?.Description || "",
            "Violation Type": vilationsType,
            "Reported By Officer": item?.PoliceStation || "",
          };
        });

        exportToExcel(exportData, "Vendor_Violation_Details");
      },
      onError: () => {
        // notifyError(" Export failed. Please try again.")
        return notifyError("Export failed. Please try again.");
      },
    });
  };

  // const isCityLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "cityuser";
  // const isZoneLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "zoneuser";
  // const isPSLogin = Cookies.get("DP_NIGHT_EYE_USER_ROLE") === "policestationuser";
  const isCityLogin = true;
  const isZoneLogin = true;
  const isPSLogin = true;

  const { data: zoneData = [] } = useZoneData(modelFilter?.cityID, Cookies.get("NIGHT_EYE_ZONE_ID"));
  const { data: policeStationData = [] } = usePoliceStationData(modelFilter?.cityID, modelFilter?.zoneID, Cookies.get("NIGHT_EYE_POLICE_STATION_ID"));
  const { data: areaData = [] } = useAreaData(modelFilter?.cityID, modelFilter.zoneID, modelFilter?.policeStationID, Cookies.get("NIGHT_EYE_AREA_ID"));
  const { data: shopData = [] } = useShopData(modelFilter?.cityID, modelFilter.zoneID, modelFilter?.policeStationID, modelFilter?.areaID);
  const { data: violationData = [] } = useGetViolatoinTypeDetails();
  const zoneOptions = zoneData?.map((ele) => ({
    value: ele?.ZoneID,
    label: ele?.ZoneName,
  }));
  const policeStationOptions = policeStationData?.map((ele) => ({
    value: ele?.PoliceStationID,
    label: ele?.PoliceStation,
  }));
  const areaOptions = areaData?.map((ele) => ({
    value: ele?.AreaID,
    label: ele?.AreaName,
  }));
  const shopOptions = shopData?.map((ele) => ({
    value: ele?.ShopDetailID,
    label: ele?.ShopName,
  }));
  const violatoinOptions = violationData?.map((ele) => ({
    value: ele?.ViolationsTypeID,
    label: ele?.ViolationsType,
  }));
  useEffect(() => {
    if (isZoneLogin && zoneOptions.length == 1) {
      setFilterData((prev) => {
        return {
          ...prev,
          zoneID: zoneOptions?.[0].value || "",
        };
      });
    } else if (isPSLogin && policeStationOptions.length == 1) {
      setFilterData((prev) => {
        return {
          ...prev,
          policeStationID: policeStationOptions?.[0].value || "",
        };
      });
    }
  }, []);

  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "38px",
      backgroundColor: "rgb(248 250 252)",
      borderColor: state.isFocused ? "#3b82f6" : "rgb(226 232 240)",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(59,130,246,0.15)" : "none",
      borderRadius: "0.5rem",
      "&:hover": { borderColor: "#94a3b8" },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "2px 12px",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1e293b",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#94a3b8",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.5rem",
      boxShadow: "0 10px 15px -3px rgba(0,0,0,0.1)",
    }),
  };

  const handleSelectFilterData = (name, value) => {
    if (name == "zoneID") {
      setModelFilter((prev) => {
        return {
          ...prev,
          [name]: value,
          policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
          areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
        };
      });
    } else if (name == "policeStationID") {
      setModelFilter((prev) => {
        return {
          ...prev,
          [name]: value,
          areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
        };
      });
    } else {
      setModelFilter((prev) => {
        return {
          ...prev,
          [name]: value,
        };
      });
    }
  };
  const handleReset = () => {
    setFilterData({
      isShopOpenCloseViolation: "",
      cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
      zoneID: Cookies.get("NIGHT_EYE_ZONE_ID") || "",
      policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
      areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
      shopDetailID: "",
      shopOwnerMobileNo: "",
      shopOwnerName: "",
      shopName: "",
      violationsTypeID: "",
      // "startDate": subDays(new Date(), 7),
      startDate: new Date(),
      endDate: new Date(),
    });
    setModelFilter({
      isShopOpenCloseViolation: "",
      cityID: Cookies.get("NIGHT_EYE_CITY_ID") || "",
      zoneID: Cookies.get("NIGHT_EYE_ZONE_ID") || "",
      policeStationID: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "",
      areaID: Cookies.get("NIGHT_EYE_AREA_ID") || "",
      shopDetailID: "",
      shopOwnerMobileNo: "",
      shopOwnerName: "",
      shopName: "",
      violationsTypeID: "",
      // "startDate": subDays(new Date(), 7),
      startDate: new Date(),
      endDate: new Date(),
    });
  };
  const handleShowHideTableDetails = (ShopReportDetailID) => {
    setOpenTableDetails((prev) => ({
      ...prev,
      [ShopReportDetailID]: !prev[ShopReportDetailID],
    }));
  };

  const directionOnMap = (data) => {
    setDirectionData(data);
    setOpenMapModel(true);
  };

  return (
    <main className="flex-1 overflow-y-auto p-3 md:px-8 scroll-smooth">
      <div className="mx-auto max-w-7xl flex flex-col gap-3">
        {/* Filters & Map Toolbar */}
        <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700">
          {/* Header with title + toggle + optional reset icon */}
          <div className="px-4 sm:px-6 py-0 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
            <div className="flex items-center gap-2.5">
              <span className="material-symbols-outlined text-blue-600 text-2xl">filter_list</span>
              <h3 className="text-base font-semibold text-slate-800 dark:text-slate-100">Filters</h3>
              <span className="text-[14px] text-slate-500 dark:text-slate-400 countcss">{totalCount}</span>
            </div>

            <div className="flex items-center gap-1.5 sm:gap-2">
              {/* Collapse / Expand Button */}
              <button
                onClick={() => setIsFiltersOpen((prev) => !prev)}
                title={isFiltersOpen ? "Collapse filters" : "Expand filters"}
                className="p-1.5 sm:p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors"
              >
                <span className="material-symbols-outlined text-xl sm:text-2xl">{isFiltersOpen ? "expand_less" : "expand_more"}</span>
              </button>

              {/* Optional: small reset icon in header */}
              <button
                onClick={handleReset}
                title="Reset filters"
                className="p-1.5 sm:p-2 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200 transition-colors hidden sm:block"
              >
                <span className="material-symbols-outlined text-xl sm:text-2xl">restart_alt</span>
              </button>
            </div>
          </div>

          {/* Collapsible content */}
          {isFiltersOpen && (
            <div className="p-4 sm:p-6 transition-all duration-200 ease-in-out">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
                {/* Zone */}
                {(isCityLogin || isZoneLogin) && (
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Zone</label>
                    <Select
                      options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_ZONE_ID") || "" }, ...zoneOptions]}
                      value={zoneOptions.find((opt) => opt.value === modelFilter?.zoneID) || null}
                      onChange={(opt) => handleSelectFilterData("zoneID", opt?.value || "")}
                      placeholder="Select Zone"
                      styles={selectStyles}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* Police Station */}
                {(isCityLogin || isZoneLogin || isPSLogin) && (
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Police Station</label>
                    <Select
                      options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_POLICE_STATION_ID") || "" }, ...policeStationOptions]}
                      value={policeStationOptions.find((opt) => opt.value === modelFilter?.policeStationID) || null}
                      onChange={(opt) => handleSelectFilterData("policeStationID", opt?.value || "")}
                      placeholder="Select Police Station"
                      styles={selectStyles}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* Area */}
                {(isCityLogin || isZoneLogin || isPSLogin) && (
                  <div className="flex flex-col gap-1.5">
                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Area</label>
                    <Select
                      options={[{ label: "Select All", value: Cookies.get("NIGHT_EYE_AREA_ID") || "" }, ...areaOptions]}
                      value={areaOptions.find((opt) => opt.value === modelFilter?.areaID) || null}
                      onChange={(opt) => handleSelectFilterData("areaID", opt?.value || "")}
                      placeholder="Select Area"
                      styles={selectStyles}
                      classNamePrefix="react-select"
                    />
                  </div>
                )}

                {/* Shop */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Shop</label>
                  <Select
                    options={[{ label: "Select All", value: "" }, ...shopOptions]}
                    value={shopOptions.find((opt) => opt.value === modelFilter?.shopDetailID) || null}
                    onChange={(opt) => handleSelectFilterData("shopDetailID", opt?.value || "")}
                    placeholder="Select Shop"
                    styles={selectStyles}
                    classNamePrefix="react-select"
                  />
                </div>
                {/* <div className="flex flex-col gap-1.5">
                                    <label className="text-xs font-medium text-slate-600 dark:text-slate-400">
                                        Shop Name
                                    </label>
                                    <input
                                        type="text"
                                        value={modelFilter?.shopName || ""}
                                        onChange={(e) => handleSelectFilterData("shopName", e.target.value)}
                                        placeholder="Search shop name..."
                                        className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                                    />
                                </div> */}

                {/* 2. Shop Owner Name */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Owner Name</label>
                  <input
                    type="text"
                    value={modelFilter?.shopOwnerName || ""}
                    onChange={(e) => handleSelectFilterData("shopOwnerName", e.target.value)}
                    placeholder="Search owner name..."
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                  />
                </div>

                {/* 3. Shop Owner Mobile No */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Owner Mobile</label>
                  <input
                    type="text"
                    value={modelFilter?.shopOwnerMobileNo || ""}
                    onChange={(e) => {
                      // Optional: allow only numbers + limited length
                      const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                      handleSelectFilterData("shopOwnerMobileNo", val);
                    }}
                    placeholder="10-digit mobile number"
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    maxLength={10}
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Violation Type</label>
                  <Select
                    options={[{ label: "Select All", value: "" }, ...violatoinOptions]}
                    value={violatoinOptions.find((opt) => opt.value === modelFilter?.violationsTypeID) || null}
                    onChange={(opt) => handleSelectFilterData("violationsTypeID", opt?.value || "")}
                    placeholder="Select Violation Type"
                    styles={selectStyles}
                    classNamePrefix="react-select"
                  />
                </div>

                {/* Start Date */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">Start Date</label>
                  <Flatpickr
                    options={{ dateFormat: "d-m-Y" }}
                    value={modelFilter?.startDate}
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    onChange={(e) => handleSelectFilterData("startDate", e?.[0])}
                    placeholder="DD-MM-YYYY"
                  />
                </div>

                {/* End Date */}
                <div className="flex flex-col gap-1.5">
                  <label className="text-xs font-medium text-slate-600 dark:text-slate-400">End Date</label>
                  <Flatpickr
                    options={{ dateFormat: "d-m-Y" }}
                    value={modelFilter?.endDate}
                    className="w-full px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-slate-50 dark:bg-slate-700 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                    onChange={(e) => handleSelectFilterData("endDate", e?.[0])}
                    placeholder="DD-MM-YYYY"
                  />
                  {!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate) && (
                    <p className="text-xs text-red-600 dark:text-red-400 mt-1">End date cannot be before start date</p>
                  )}
                </div>
                <div className="flex flex-col flex-nowrap gap-1.5">
                  {/* <button
                    onClick={handleReset}
                    className="px-5 py-2.5 text-sm font-medium rounded-lg border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors min-w-[100px]"
                >
                    Reset
                </button> */}
                  <div className="flex justify-start mt-5">
                    <button
                      onClick={handleFilterSearch}
                      disabled={!validateStartAndEndDate(modelFilter?.startDate, modelFilter?.endDate)}
                      className="px-4 py-2.5 mr-2 text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed min-w-[100px]  "
                    >
                      Filter
                    </button>

                    <button
                      onClick={handleExport}
                      disabled={isExporting}
                      className="px-4 py-2.5 text-sm font-medium bg-green-600 hover:bg-green-700 text-white rounded-lg shadow-sm transition-all disabled:opacity-50 disabled:cursor-not-allowed min-w-[100px] flex items-center justify-center gap-2"
                    >
                      {isExporting ? <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" /> : "Excel"}
                    </button>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
            </div>
          )}
        </div>

        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    <div
                        className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
                    >
                        <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                            <span className="material-symbols-outlined text-amber-600" style={{ fontSize: 64 }}>account_circle</span>
                        </div>
                        <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">Owner</p>
                        <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">
                            {vendorCount?.OwnerCount || "0"}
                        </p>
                    </div>

                    <div
                        className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
                    >
                        <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                            <span className="material-symbols-outlined text-purple-600" style={{ fontSize: 64 }}>house</span>
                        </div>
                        <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">On Rent</p>
                        <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">
                             {vendorCount?.RentCount || "0"}
                        </p>
                    </div>
                 
                    <div
                        className="cursor-pointer flex flex-col gap-2 rounded-xl p-6 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-sm relative overflow-hidden group hover:shadow-md transition-shadow"
                    >
                        <div className="absolute right-0 top-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity">
                            <span className="material-symbols-outlined text-orange-600" style={{ fontSize: 64 }}>people</span>
                        </div>
                        <p className="text-[#4c739a] dark:text-gray-400 text-sm font-semibold uppercase tracking-wider">On Sub Tenant</p>
                        <p className="text-[#0d141b] dark:text-white text-3xl font-bold leading-none">
                             {vendorCount?.SubTenantCount || "0"}
                        </p>
                    </div>
                </div> */}

        <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-lg border border-slate-200/80 dark:border-slate-700/50 overflow-hidden">
          <div className="m-2">
            <PageCountSelect rowsPerPage={rowsPerPage} handleRowsChange={handleRowsChange} />
          </div>
          <div className="overflow-x-auto">
            {isLoading || isFetching ? (
              <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-800">
                <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
                  <tr>
                    <th className="py-4 pl-6 pr-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Sr No</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                      {/* Shop Name / Mobile Number */}
                      Shop Name
                    </th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Owner Name / Mobile Number</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Area</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Reported Date</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Reported Time</th>
                    {/* <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                                            Adress
                                        </th> */}
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">More Details</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Live Image</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Reported By Officer</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">View</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 dark:divide-slate-800/70">
                  {[...Array(8)].map((_, i) => (
                    <ShimmerRow key={i} />
                  ))}
                </tbody>
              </table>
            ) : currentItems.length === 0 ? (
              // Beautiful No Data Found UI
              <NoDataFound />
            ) : (
              <table className="min-w-full divide-y divide-slate-200 dark:divide-slate-700">
                <thead className="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10">
                  <tr>
                    <th className="py-4 pl-6 pr-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Sr No</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                      {/* Shop Name / Mobile Number */}
                      Shop Name
                    </th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Owner Name / Mobile Number</th>
                    <th className="py-4 px-3 pl-6 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Area</th>
                    <th className="py-4 px-3 pl-6 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Reported Date</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Reported Time</th>
                    {/* <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
                                            Adress
                                        </th> */}
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">More Details</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Live Image</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">Reported By Officer</th>
                    <th className="py-4 px-3 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">View</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-200 dark:divide-slate-700">
                  {pages[currentPage]?.data?.length
                    ? pages[currentPage]?.data.map((shop, idx) => {
                        const absoluteIndex = currentPage * rowsPerPage + idx + 1;
                        const imageUrl = shop.Attachment1 ? `${NIGHT_EYE_IMG_URL}/SmartCollection/ShopReportImage/${shop.Attachment1}` : null;
                        return (
                          <>
                            <tr key={idx} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                              <td className=" py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">{absoluteIndex}</td>
                              <td className=" py-4 pl-4 pr-3 text-sm font-medium text-slate-900 dark:text-white sm:pl-6">
                                <div className="flex flex-col">
                                  <p className="text-[#0d141b] dark:text-white font-bold text-base">{shop.ShopName || "—"}</p>
                                  {/* <p className="text-sm text-[#4c739a] dark:text-gray-200">
                                                                {shop.ShopMobileNo1 || '—'}
                                                            </p> */}
                                </div>
                              </td>
                              <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                <p className="text-[#0d141b] dark:text-white font-bold text-base">{shop?.ShopOwnerDetail?.[0]?.Name || "—"}</p>
                                <p className="text-sm text-[#4c739a] dark:text-gray-200">{shop?.ShopOwnerDetail?.[0]?.MobileNo || "—"}</p>
                              </td>
                              <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                <p className="text-sm text-[#0d141b] dark:text-gray-200">{shop.AreaName || "—"}</p>
                              </td>
                              <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                <p className="text-sm text-[#0d141b] dark:text-gray-200">{shop.ReportDate || "—"}</p>
                              </td>
                              <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                <p className="text-sm text-[#0d141b] dark:text-gray-200">{shop.ReportTime || "—"}</p>
                              </td>
                              <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                <p className="text-sm text-[#0d141b] dark:text-gray-200">
                                  <span onClick={() => handleShowHideTableDetails(shop?.ShopReportDetailID)} className="material-symbols-outlined cursor-pointer text-xl">
                                    visibility
                                  </span>
                                  {/* {shop.Description || '—'} */}
                                </p>
                              </td>

                              <td>
                                <div
                                  className="size-12 rounded-lg bg-cover bg-center shrink-0 border border-gray-200 dark:border-gray-600"
                                  // style={{
                                  //   backgroundImage: shop.ShopImage ? `url(/uploads/shop/${shop.ShopImage})` : 'none',
                                  // }}
                                >
                                  {!shop.Attachment1 ? (
                                    <div className="h-full flex items-center justify-center text-gray-400">
                                      <span className="material-symbols-outlined">store</span>
                                    </div>
                                  ) : (
                                    <div className="h-full flex items-center justify-center text-gray-400">
                                      <div
                                        className="size-10 rounded-lg bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 cursor-pointer overflow-hidden group relative"
                                        onClick={() => openModal(imageUrl)}
                                      >
                                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors flex items-center justify-center">
                                          <span className="material-symbols-outlined text-white opacity-0 group-hover:opacity-100 text-xl">visibility</span>
                                        </div>
                                        <img
                                          src={imageUrl}
                                          alt="Shop close proof"
                                          className="w-full h-full object-cover"
                                          onError={(e) => {
                                            e.target.src = "/fallback-proof-placeholder.jpg"; // optional fallback
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td className=" px-3 py-4 text-sm text-slate-500 dark:text-slate-400">
                                <p className="text-sm text-[#0d141b] dark:text-gray-200">{shop.PoliceStation || "—"}</p>
                              </td>
                              <td className="whitespace-wrap px-3 py-4 text-sm text-center">
                                <button
                                  onClick={() => directionOnMap(shop)}
                                  className="flex items-center gap-1.5 w-full justify-center px-2 py-1.5 me-2 mb-2 text-xs font-bold text-white bg-primary bg-primary-600 rounded-lg hover:bg-primary-700 shadow-sm shadow-primary-500/30 transition-colors"
                                >
                                  <span className="material-symbols-outlined text-[16px]">map</span>
                                  On Map
                                </button>

                                {/* Modal */}
                                {openMapModel && (
                                  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 directiondivMap">
                                    <div className="bg-white rounded-lg w-[100%] max-w-5xl p-4 relative">
                                      <button onClick={() => setOpenMapModel(false)} className="absolute top-2 right-2 text-gray-600 mapzindex">
                                        ✕
                                      </button>

                                      <DirectionMap directionData={directionData} />
                                    </div>
                                  </div>
                                )}
                              </td>
                            </tr>
                            <AnimatePresence>
                              {openTableDetails[shop?.ShopReportDetailID] && (
                                <motion.tr
                                  initial={{ opacity: 0, height: 0 }}
                                  animate={{ opacity: 1, height: "auto" }}
                                  exit={{ opacity: 0, height: 0 }}
                                  transition={{ duration: 0.3, ease: "easeOut" }}
                                  className="bg-gray-50 dark:bg-slate-800/20"
                                >
                                  <td colSpan={9} className="p-4 sm:p-5">
                                    <div className="bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm">
                                      {/* Optional small header */}
                                      <div className="px-4 py-2.5 bg-slate-50 dark:bg-slate-700/40 border-b border-slate-200 dark:border-slate-700">
                                        <h4 className="text-sm font-medium text-slate-700 dark:text-slate-300">Report Details – {shop.ShopName || "Shop"}</h4>
                                      </div>

                                      <div className="p-4 sm:p-5 space-y-5">
                                        {/* Description */}
                                        <div>
                                          <h5 className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-1.5">Description</h5>
                                          <div className="text-sm leading-relaxed text-slate-700 dark:text-slate-300 whitespace-pre-line">
                                            {shop.Description || <span className="italic text-slate-400">No description provided</span>}
                                          </div>
                                        </div>

                                        {/* Violations – compact chips */}
                                        <div>
                                          <h5 className="text-xs font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-1.5">Violation Types</h5>
                                          {shop?.ShopReportViolationsDetail?.length > 0 ? (
                                            <div className="flex flex-wrap gap-2.5">
                                              {shop.ShopReportViolationsDetail.map((v) => (
                                                <div
                                                  key={v.ShopReportViolationDetailID}
                                                  className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium border ${
                                                    v.IsShopOpenCloseViolation
                                                      ? "bg-red-50 text-red-800 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-800/50"
                                                      : "bg-slate-50 text-slate-800 border-slate-200 dark:bg-slate-800/50 dark:text-slate-200 dark:border-slate-700"
                                                  }`}
                                                >
                                                  {v.ViolationsType}
                                                  {v.IsShopOpenCloseViolation && <span className="text-xs font-semibold text-red-600 dark:text-red-400">★</span>}
                                                </div>
                                              ))}
                                            </div>
                                          ) : (
                                            <p className="text-sm text-slate-500 dark:text-slate-400 italic">No violation types recorded</p>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </td>
                                </motion.tr>
                              )}
                            </AnimatePresence>
                          </>
                        );
                      })
                    : ""}
                </tbody>
              </table>
            )}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 px-4 sm:px-6 py-4">
          <PageEntries start={start} end={end} totalCount={totalCount} />

          <PaginationButtons currentPage={currentPage} setCurrentPage={setCurrentPage} goToPage={goToPage} pages={pages} hasNextPage={hasNextPage} fetchNextPage={fetchNextPage} />
        </div>
        {selectedImage && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={closeModal}>
            <div className="relative max-w-5xl max-h-[90vh] w-full h-full rounded-xl overflow-hidden shadow-2xl" onClick={(e) => e.stopPropagation()}>
              {/* Close button */}
              <button
                className="absolute top-4 right-4 z-10 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
                onClick={closeModal}
                aria-label="Close modal"
              >
                <span className="material-symbols-outlined">close</span>
              </button>

              {/* Image */}
              <img
                src={selectedImage}
                alt="Full size shop close proof"
                className="w-full h-full object-contain bg-slate-900"
                onError={(e) => {
                  e.target.src = "/fallback-large-placeholder.jpg";
                }}
              />
            </div>
          </div>
        )}
      </div>
    </main>
  );
};

export default ViolationVendorList;
